export const games = [
  {
    id: 1,
    name: '星际征途：无尽前线',
    category: 'action',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20first%20person%20shooter%20game%20scene%20with%20soldiers%20in%20advanced%20armor%20fighting%20aliens%20on%20a%20distant%20planet%2C%20dramatic%20lighting%20with%20laser%20beams%20and%20explosions%2C%20dark%20atmospheric%20background%2C%20game%20art%20style%2C%20high%20contrast%2C%20epic%20cinematic%20composition&width=800&height=600&seq=game-action-01&orientation=landscape',
    rating: 4.8,
    players: '250万+',
    description: '在浩瀚宇宙中展开史诗级战役，扮演精英战士对抗外星入侵，体验前所未有的星际射击快感。',
    tags: ['热门', '多人对战', '科幻'],
    releaseDate: '2025-06-15',
  },
  {
    id: 2,
    name: '幻境传说：暗影觉醒',
    category: 'rpg',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20role%20playing%20game%20with%20a%20hero%20wielding%20a%20glowing%20sword%20in%20a%20mystical%20forest%2C%20magical%20particles%20floating%2C%20ancient%20ruins%20in%20background%2C%20dark%20mysterious%20atmosphere%2C%20game%20art%20style%2C%20dramatic%20lighting&width=800&height=600&seq=game-rpg-02&orientation=landscape',
    rating: 4.9,
    players: '380万+',
    description: '踏入暗影世界，揭开千年之谜。自由探索广阔开放世界，收集神器、培养角色、结盟作战。',
    tags: ['开放世界', '剧情驱动', '多人联机'],
    releaseDate: '2025-03-20',
  },
  {
    id: 3,
    name: '王者征途：军团之战',
    category: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Strategic%20war%20game%20with%20massive%20army%20formations%20on%20a%20battlefield%2C%20medieval%20fantasy%20setting%20with%20castles%20and%20siege%20weapons%2C%20tactical%20overhead%20view%2C%20dramatic%20clouds%20and%20lighting%2C%20game%20art%20style%2C%20epic%20scale&width=800&height=600&seq=game-strategy-03&orientation=landscape',
    rating: 4.7,
    players: '180万+',
    description: '指挥你的军团征战四方，策略布局决定胜负。招募传奇英雄，打造无敌阵容征服大陆。',
    tags: ['策略', '军团作战', 'PVP'],
    releaseDate: '2025-01-10',
  },
  {
    id: 4,
    name: '极限竞速：街头狂飙',
    category: 'sports',
    image: 'https://readdy.ai/api/search-image?query=High-speed%20racing%20game%20with%20sports%20cars%20drifting%20through%20a%20neon-lit%20city%20street%20at%20night%2C%20motion%20blur%20effects%2C%20rain-slicked%20roads%2C%20vibrant%20city%20lights%2C%20game%20art%20style%2C%20dynamic%20action%20shot&width=800&height=600&seq=game-sports-04&orientation=landscape',
    rating: 4.6,
    players: '150万+',
    description: '在霓虹闪烁的都市街头体验极速狂飙，定制你的专属座驾，挑战全球赛车高手。',
    tags: ['竞速', '改装', '多人在线'],
    releaseDate: '2025-04-05',
  },
  {
    id: 5,
    name: '糖果消消乐大冒险',
    category: 'casual',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20candy%20matching%20puzzle%20game%20with%20vibrant%20sweet%20treats%20and%20magical%20effects%2C%20bright%20playful%20background%20with%20rainbow%20colors%2C%20whimsical%20game%20art%20style%2C%20cheerful%20and%20inviting%20atmosphere&width=800&height=600&seq=game-casual-05&orientation=landscape',
    rating: 4.5,
    players: '500万+',
    description: '五彩缤纷的消除世界，轻松上手乐趣无穷。数千关卡等你挑战，与好友一起比拼高分。',
    tags: ['消除', '休闲', '社交'],
    releaseDate: '2025-05-20',
  },
  {
    id: 6,
    name: '暗影突袭：幽灵行动',
    category: 'action',
    image: 'https://readdy.ai/api/search-image?query=Tactical%20stealth%20action%20game%20with%20a%20soldier%20in%20dark%20tactical%20gear%20infiltrating%20an%20enemy%20base%20at%20night%2C%20smoke%20and%20shadows%2C%20silenced%20weapons%2C%20intense%20atmosphere%2C%20game%20art%20style%2C%20cinematic%20lighting&width=800&height=600&seq=game-action-06&orientation=landscape',
    rating: 4.8,
    players: '200万+',
    description: '化身幽灵特工执行秘密任务，潜行渗透、精准狙击，在暗影中完成不可能的任务。',
    tags: ['潜行', '战术', '单人战役'],
    releaseDate: '2025-07-01',
  },
  {
    id: 7,
    name: '龙族传说：起源',
    category: 'rpg',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20dragon-themed%20role%20playing%20game%20with%20a%20massive%20dragon%20soaring%20above%20a%20medieval%20kingdom%2C%20knights%20and%20mages%20below%2C%20stormy%20sky%20with%20lightning%2C%20epic%20scale%2C%20game%20art%20style%2C%20dramatic%20composition&width=800&height=600&seq=game-rpg-07&orientation=landscape',
    rating: 4.9,
    players: '420万+',
    description: '在龙族横行的奇幻世界中，驯服巨龙、建立王国，书写属于你的龙骑士传说。',
    tags: ['奇幻', '龙骑士', '开放世界'],
    releaseDate: '2025-02-14',
  },
  {
    id: 8,
    name: '脑力风暴：极限解谜',
    category: 'casual',
    image: 'https://readdy.ai/api/search-image?query=Mind-bending%20puzzle%20game%20with%20geometric%20shapes%20and%20optical%20illusions%20floating%20in%20a%20minimalist%20space%2C%20clean%20modern%20design%2C%20glowing%20neon%20accents%2C%20cerebral%20atmosphere%2C%20game%20art%20style&width=800&height=600&seq=game-casual-08&orientation=landscape',
    rating: 4.4,
    players: '90万+',
    description: '挑战你的智力极限，数百个精心设计的谜题等待破解。锻炼思维，收获满满的成就感。',
    tags: ['解谜', '脑力', '单机'],
    releaseDate: '2025-06-01',
  },
  {
    id: 9,
    name: '足球大师：绿茵传奇',
    category: 'sports',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20football%20soccer%20game%20with%20players%20in%20action%20on%20a%20stadium%20pitch%2C%20dramatic%20stadium%20lights%2C%20crowd%20cheering%2C%20intense%20match%20moment%2C%20game%20art%20style%2C%20sports%20photography%20feel&width=800&height=600&seq=game-sports-09&orientation=landscape',
    rating: 4.7,
    players: '300万+',
    description: '组建你的梦幻球队，在绿茵场上驰骋争锋。真实物理引擎带来最纯粹的足球体验。',
    tags: ['足球', '体育', '俱乐部'],
    releaseDate: '2025-03-01',
  },
  {
    id: 10,
    name: '星际争霸：银河帝国',
    category: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Space%20strategy%20game%20with%20massive%20starship%20fleets%20battling%20in%20deep%20space%2C%20laser%20fire%20and%20explosions%2C%20planets%20and%20nebulas%20in%20background%2C%20grand%20scale%2C%20game%20art%20style%2C%20epic%20cinematic&width=800&height=600&seq=game-strategy-10&orientation=landscape',
    rating: 4.8,
    players: '220万+',
    description: '从一颗星球开始建立你的银河帝国，发展科技、组建舰队、征服星系。',
    tags: ['太空', '即时战略', '多人'],
    releaseDate: '2025-05-15',
  },
  {
    id: 11,
    name: '巅峰对决：英雄竞技场',
    category: 'action',
    image: 'https://readdy.ai/api/search-image?query=Hero-based%20arena%20battle%20game%20with%20powerful%20warriors%20clashing%20in%20a%20colosseum-like%20arena%2C%20magical%20abilities%20and%20special%20effects%2C%20crowd%20surrounding%2C%20dramatic%20lighting%2C%20game%20art%20style&width=800&height=600&seq=game-action-11&orientation=landscape',
    rating: 4.6,
    players: '180万+',
    description: '选择你的英雄，在竞技场中一决高下。每个英雄拥有独特技能，策略配合制胜关键。',
    tags: ['MOBA', '竞技', '团队'],
    releaseDate: '2025-04-20',
  },
  {
    id: 12,
    name: '深海探险：亚特兰蒂斯',
    category: 'rpg',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20adventure%20role%20playing%20game%20with%20a%20diver%20exploring%20ancient%20ruins%20deep%20in%20the%20ocean%2C%20bioluminescent%20creatures%2C%20sunken%20temples%2C%20mysterious%20blue-green%20lighting%2C%20game%20art%20style&width=800&height=600&seq=game-rpg-12&orientation=landscape',
    rating: 4.5,
    players: '120万+',
    description: '潜入深海探索失落文明，发现亚特兰蒂斯的秘密。绝美的海底世界等你来探索。',
    tags: ['冒险', '探索', '单人'],
    releaseDate: '2025-08-01',
  },
];